import { render, staticRenderFns } from "./TeamsView.vue?vue&type=template&id=08027a07&scoped=true&"
import script from "./TeamsView.vue?vue&type=script&lang=js&"
export * from "./TeamsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08027a07",
  null
  
)

export default component.exports